import React from 'react'
const domain = "http://" + window.location.host;
const Image = (props) => {
  return (
    <img src={domain + '/' + props.src} alt={props.title} className={props.className} />
  )
}

export default Image